// extracted by mini-css-extract-plugin
export var content = "PrimaryCard-module--content--72b1c";
export var contentContainer = "PrimaryCard-module--contentContainer--d7559";
export var contentContainerInner = "PrimaryCard-module--contentContainerInner--36262";
export var contentContainerText = "PrimaryCard-module--contentContainerText--bc4ac";
export var heading = "PrimaryCard-module--heading--1f3a7";
export var image = "PrimaryCard-module--image--b9ec7";
export var logo = "PrimaryCard-module--logo--d3e21";
export var primary = "PrimaryCard-module--primary--e70a3";
export var primaryLink = "PrimaryCard-module--primaryLink--95265";
export var subheading = "PrimaryCard-module--subheading--5e7a1";